export default {
    apiKey: 'AIzaSyByy0BNdRIVE90lI08BubgIpaRrs1qs_40',
    authDomain: 'kizi404.firebaseapp.com',
    databaseURL: 'https://kizi404.firebaseio.com',
    projectId: 'kizi404',
    storageBucket: 'kizi404.appspot.com',
    messagingSenderId: '40060116259',
    appId: '1:40060116259:web:48e3f07ce7c66a50bc8096'
}